import { basename as u } from "path";
import d, { toRaw as m } from "vue";
import { t as l, n as p } from "./chunks/toast-WB-IZBJw.mjs";
import { g as _, e as F, f as I, c as H, d as N, b as O, T as L, a as x, k as B, j as D, s as R, h as U, l as k, i as j } from "./chunks/toast-WB-IZBJw.mjs";
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const w = (e, t, i = () => {
}) => {
  const a = document.createElement("div");
  (document.querySelector(t?.container) || document.body).appendChild(a);
  const s = new d({
    el: a,
    name: "VueDialogHelper",
    render: (o) => o(e, {
      props: t,
      on: {
        close: (...n) => {
          i(...n.map((h) => m(h))), s.$destroy();
        }
      }
    })
  });
}, b = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-move" viewBox="0 0 24 24"><path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></svg>', f = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-multiple" viewBox="0 0 24 24"><path d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z" /></svg>';
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var A = /* @__PURE__ */ ((e) => (e[e.Choose = 1] = "Choose", e[e.Move = 2] = "Move", e[e.Copy = 3] = "Copy", e[e.CopyMove = 4] = "CopyMove", e[e.Custom = 5] = "Custom", e))(A || {});
class g extends Error {
}
class v {
  title;
  multiSelect;
  mimeTypeFilter;
  directoriesAllowed;
  buttons;
  path;
  filter;
  container;
  disabledNavigation;
  constructor(t, i, a, r, s, o, n, h, c = !1) {
    this.title = t, this.multiSelect = i, this.mimeTypeFilter = a, this.directoriesAllowed = r, this.path = o, this.filter = n, this.buttons = s, this.container = h, this.disabledNavigation = c;
  }
  /**
   * Pick files using the FilePicker
   *
   * @return Promise with array of picked files or rejected promise on close without picking
   */
  async pick() {
    const { FilePickerVue: t } = await import("./chunks/index-RkOaxczZ.mjs");
    return new Promise((i, a) => {
      w(t, {
        allowPickDirectory: this.directoriesAllowed,
        buttons: this.buttons,
        container: this.container,
        name: this.title,
        path: this.path,
        mimetypeFilter: this.mimeTypeFilter,
        multiselect: this.multiSelect,
        filterFn: this.filter,
        disabledNavigation: this.disabledNavigation
      }, (...r) => {
        const [s] = r;
        !Array.isArray(s) || s.length === 0 ? a(new g("FilePicker: No nodes selected")) : this.multiSelect ? i(s.map((o) => o.path)) : i(s[0]?.path || "/");
      });
    });
  }
}
class T {
  title;
  multiSelect = !1;
  mimeTypeFilter = [];
  directoriesAllowed = !1;
  path;
  filter;
  buttons = [];
  container;
  disabledNavigation = !1;
  /**
   * Construct a new FilePicker
   *
   * @param title Title of the FilePicker
   */
  constructor(t) {
    this.title = t;
  }
  /**
   * Set the container where the FilePicker will be mounted
   * By default 'body' is used
   *
   * @param container The dialog container
   */
  setContainer(t) {
    return this.container = t, this;
  }
  /**
   * Enable or disable picking multiple files
   *
   * @param ms True to enable picking multiple files, false otherwise
   */
  setMultiSelect(t) {
    return this.multiSelect = t, this;
  }
  /**
   * Add allowed MIME type
   *
   * @param filter MIME type to allow
   */
  addMimeTypeFilter(t) {
    return this.mimeTypeFilter.push(t), this;
  }
  /**
   * Set allowed MIME types
   *
   * @param filter Array of allowed MIME types
   */
  setMimeTypeFilter(t) {
    return this.mimeTypeFilter = t, this;
  }
  /**
   * Add a button to the FilePicker
   * Note: This overrides any previous `setButtonFactory` call
   *
   * @param button The button
   */
  addButton(t) {
    return typeof this.buttons == "function" && (console.warn("FilePicker buttons were set to factory, now overwritten with button object."), this.buttons = []), this.buttons.push(t), this;
  }
  /**
   * Set the button factory which is used to generate buttons from current view, path and selected nodes
   * Note: This overrides any previous `addButton` call
   *
   * @param factory The button factory
   */
  setButtonFactory(t) {
    return this.buttons = t, this;
  }
  /**
   * Set FilePicker type based on legacy file picker types
   * @param type The legacy filepicker type to emulate
   * @deprecated Use `addButton` or `setButtonFactory` instead as with setType you do not know which button was pressed
   */
  setType(t) {
    return this.buttons = (i, a) => {
      const r = [], s = i?.[0]?.attributes?.displayName || i?.[0]?.basename, o = s || u(a);
      if (t === 1) {
        let n = l("Choose");
        i.length === 1 ? n = l("Choose {file}", { file: s }) : this.multiSelect && (n = p("Choose %n file", "Choose %n files", i.length)), r.push({
          callback: () => {
          },
          type: "primary",
          label: n
        });
      }
      return (t === 4 || t === 3) && r.push({
        callback: () => {
        },
        label: o ? l("Copy to {target}", { target: o }) : l("Copy"),
        type: "primary",
        icon: f
      }), (t === 2 || t === 4) && r.push({
        callback: () => {
        },
        label: o ? l("Move to {target}", { target: o }) : l("Move"),
        type: t === 2 ? "primary" : "secondary",
        icon: b
      }), r;
    }, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  allowDirectories(t = !0) {
    return this.directoriesAllowed = t, this;
  }
  /**
   * Set starting path of the FilePicker
   *
   * @param path Path to start from picking
   */
  startAt(t) {
    return this.path = t, this;
  }
  /**
   * Add filter function to filter file list of FilePicker
   *
   * @param filter Filter function to apply
   */
  setFilter(t) {
    return this.filter = t, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  disableNavigation() {
    return this.disabledNavigation = !0, this;
  }
  /**
   * Construct the configured FilePicker
   */
  build() {
    return new v(
      this.title,
      this.multiSelect,
      this.mimeTypeFilter,
      this.directoriesAllowed,
      this.buttons,
      this.path,
      this.filter,
      this.container,
      this.disabledNavigation
    );
  }
}
function S(e) {
  return new T(e);
}
export {
  v as FilePicker,
  T as FilePickerBuilder,
  g as FilePickerClosed,
  A as FilePickerType,
  _ as TOAST_ARIA_LIVE_ASSERTIVE,
  F as TOAST_ARIA_LIVE_OFF,
  I as TOAST_ARIA_LIVE_POLITE,
  H as TOAST_DEFAULT_TIMEOUT,
  N as TOAST_PERMANENT_TIMEOUT,
  O as TOAST_UNDO_TIMEOUT,
  L as ToastAriaLive,
  x as ToastType,
  S as getFilePickerBuilder,
  B as showError,
  D as showInfo,
  R as showMessage,
  U as showSuccess,
  k as showUndo,
  j as showWarning,
  w as spawnDialog
};
